import { createContext, useContext } from "react";

/**
 * When a product is opened in an in-app tab (ProductV2 + MemoryRouter),
 * back navigation should return to the catalog tab instead of the memory router's /product.
 */
export const ProductCatalogTabContext = createContext(null);

export function useProductCatalogTabContext() {
  return useContext(ProductCatalogTabContext);
}
